import { resolveDashboardSharedBodyKey } from "@frontend-shared/utils";
import { LayoutDashboard } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";
import type { IDashboardSharedCardProps } from "./types";

// NOTE: NSAI-6940 — the body names the role in a whole sentence per role
// ("You can view it" / "You can view and edit it") rather than a raw
// "viewer" / "editor" value, so it reads naturally in every locale.
const DashboardSharedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewDashboard,
}: IDashboardSharedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewDashboard = useCallback(
    (): void =>
      onViewDashboard({
        dashboardUuid: data.dashboardUuid,
        projectUuid: data.projectUuid,
      }),
    [onViewDashboard, data.dashboardUuid, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="dashboard_shared"
      createdAt={createdAt}
      isRead={isRead}
      icon={<LayoutDashboard className="h-5 w-5 text-sky-500" />}
      iconBgClassName="bg-sky-500/10"
      ctaLabel={t("view_dashboard")}
      onCtaClick={handleViewDashboard}
      body={t(resolveDashboardSharedBodyKey(data.permissionLevel), {
        ownerName: data.ownerName,
        dashboardName: data.dashboardName,
      })}
    />
  );
};

export const DashboardSharedCard = memo(DashboardSharedCardComponent);
